module.exports = __webpack_public_path__ + "static/media/6.4.807be765.zip";